class RandomImager {
    constructor(node) {
        this.node = node;
        this.data = JSON.parse(node.dataset.images);
        this.cells = node.querySelectorAll('.logo');

        this.rotationDelayMs = 1250;
        this.animationDelayMs = 100;
        this.currentIndex = 10;

        this.nextValues = [];
        this.generateNextValues();

        if (this.cells && this.data) {
            setInterval(() => {
                this.swapLogo();
            }, this.rotationDelayMs);
        }
    }

    generateNextValues() {
        if (this.nextValues.length) return;

        const arr = [...Array(10).keys()];

        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }

        this.nextValues = arr;
    }

    getNextImage() {
        const { data } = this;
        if (data.length && data[this.currentIndex + 1]) {
            this.currentIndex += 1;
        } else {
            this.currentIndex = 0;
        }

        const image = data[this.currentIndex];
        return image;
    }

    swapLogo() {
        const nextImage = this.getNextImage();

        this.generateNextValues();
        const targetID = this.nextValues.pop();
        const target = this.cells[targetID].querySelector('img');

        target.classList.add('animating');

        setTimeout(() => {
            target.src = nextImage.src;
            target.alt = nextImage.alt;
            setTimeout(() => {
                target.classList.remove('animating');
            }, this.animationDelayMs);
        }, this.animationDelayMs);
    }

    static preloadImage(src) {
        return new Promise(function (resolve, reject) {
            const image = new Image();
            image.onload = function () {
                resolve(src);
            };
            image.onerror = reject;
            image.src = src;
        });
    }

    static init() {
        const node = document.querySelector('.partners__dynamics');
        if (node && node.dataset.images) new RandomImager(node);
    }
}

export default RandomImager;
